// Module
var code = "<react-component name=\"MembershipPage\"></react-component>\n";
// Exports
module.exports = code;